import {
  Autocomplete,
  Divider,
  Stack,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  Select,
  Chip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ListCheckBox } from "../generals/ListCheckBox";
import { useEffect, useMemo, useState } from "react";

export const VisibilityList = ({
  formValues,
  handleInputChange,
  userList,
  checked,
  setChecked,
  isInitial = false,
  edit = false,
  userWithActivePosition,
}) => {
  const { t } = useTranslation("global");
  const { clubFilter, isActiveFilter } = formValues;
  const [otherUsers, setOtherUsers] = useState([]);

  const clubsList = [...new Set(userList.map((user) => user.club))];

  const isActive =
    isActiveFilter === "Activos"
      ? true
      : isActiveFilter === "Inactivos"
      ? false
      : null;

  const filteredUsers = useMemo(() => {
    let filtered = [...userList];

    if (isActiveFilter === "Activos") {
      filtered = filtered.filter((user) => user.isActive === isActive);
    } else if (isActiveFilter === "Posición activa") {
      filtered = filtered.filter((user) =>
        userWithActivePosition.some((activeUser) => activeUser.id === user.id)
      );
    }

    if (clubFilter[0] !== "Todos los clubs") {
      filtered = filtered.filter((user) => clubFilter.includes(user.club));
    }

    return filtered;
  }, [userList, isActiveFilter, clubFilter, isActive, userWithActivePosition]);

  const [addUsers, setAddUsers] = useState(
    checked.filter(
      (userChecked) =>
        !filteredUsers.some((userFiltered) => userFiltered === userChecked)
    )
  );

  const [isInitialRender, setIsInitialRender] = useState(isInitial);

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
    } else {
      setChecked(filteredUsers);
      setAddUsers([]);
    }
    setOtherUsers(
      userList.filter(
        (user) =>
          !filteredUsers.some((filteredUser) => user.id === filteredUser.id)
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActiveFilter, clubFilter]);

  const onChangeSelect = (event) => {
    const selectedValues = event.target.value;
    const currentSelectedIsAll =
      selectedValues[selectedValues.length - 1] === "Todos los clubs";
    const fistSelectedIsAll = selectedValues[0] === "Todos los clubs";

    if (currentSelectedIsAll) {
      handleInputChange({
        target: { name: "clubFilter", value: ["Todos los clubs"] },
      });
    } else if (fistSelectedIsAll) {
      handleInputChange({
        target: {
          name: "clubFilter",
          value: [selectedValues[selectedValues.length - 1]],
        },
      });
    } else {
      // Actualiza el estado con los valores seleccionados
      handleInputChange({
        target: { name: "clubFilter", value: selectedValues },
      });
    }
  };

  return (
    <Stack gap={4} mt={8}>
      <Stack>
        <Typography color="primary" variant="h6">
          {t("sendNotifications.visibility")}
        </Typography>
        <Divider sx={{ marginTop: 2, marginBottom: 1 }} />
      </Stack>
      <Stack gap={2} direction="row">
        <FormControl sx={{ width: "100%" }}>
          <Select
            multiple
            size="small"
            value={clubFilter}
            name="clubFilter"
            onChange={onChangeSelect}
            renderValue={(selected) => (
              <div>
                {selected.map((value) => (
                  <Chip key={value} label={value} sx={{ marginRight: 1 }} />
                ))}
              </div>
            )}
          >
            {[...clubsList, "Todos los clubs"].map((club) => (
              <MenuItem key={club} value={club}>
                {club}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Stack gap={2} direction="row">
        <Autocomplete
          disablePortal
          options={["Activos", "Posición activa", "Todos los socios"]}
          size="small"
          renderInput={(params) => (
            <TextField {...params} variant="outlined" name="isActiveFilter" />
          )}
          value={isActiveFilter}
          onSelect={handleInputChange}
          fullWidth
        />
      </Stack>
      <ListCheckBox
        listText={filteredUsers}
        setChecked={setChecked}
        checked={checked}
        edit={edit}
      />
      <Stack alignItems="flex-end"></Stack>
      <Autocomplete
        disablePortal
        options={otherUsers}
        getOptionLabel={(option) =>
          option.name
            ? `${option.idCrm} - ${option.name} ${option.surnames}`
            : "Elegir inversor"
        }
        size="small"
        isOptionEqualToValue={(option, value) => {
          if (value === "Elegir inversor") return true;
          return option.id === value.id;
        }}
        value={"Elegir inversor"} // TODO: NO RELLENA EL AUTOCOMPLETE CON INVERSORES
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            name="isActiveFilter"
            label="Elegir inversor"
          />
        )}
        onChange={(event, value) => {
          if (value) {
            setChecked((prevValue) => [...prevValue, value]);
            setAddUsers((prevUsers) => [...prevUsers, value]);
            setOtherUsers((prevValue) =>
              prevValue.filter((user) => user.id !== value.id)
            );
          }
        }}
      />
      <ListCheckBox
        listText={addUsers}
        setChecked={setChecked}
        checked={checked}
        edit={edit}
      />
    </Stack>
  );
};
